import { useContext } from 'react';

import { StoreContext } from '../contexts/StoreContext';

const getStoreSlug = (value) => {
    const key = String(value || '').trim().toLowerCase();

    if (key.includes('netto')) return 'netto';
    if (key.includes('bilka')) return 'bilka';
    if (key.includes('super')) return 'superbrugsen';
    if (key.includes('dagli')) return 'daglibrugsen';
    if (key.includes('tex')) return 'foetex';
    if (key.includes('kvickly')) return 'kvickly';
    if (key.includes('lidl')) return 'lidl';
    if (key.includes('meny')) return 'meny';
    if (key.includes('min')) return 'minkoebmand';
    if (key.includes('rema')) return 'rema1000';
    if (key.includes('spar')) return 'spar';
    if (key.includes('coop') || key.includes('365')) return 'coop365';

    return key.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
};

const StoreSelector = (props) => {
    const { stores, setStores } = useContext(StoreContext);
    const normalizedStoreKey = getStoreSlug(props.storeName);
    const displayName = props.displayName || props.storeName;
    const isSelected = stores[props.storeName].selected;
    const isDisabled = Boolean(props.disabled);
    const isLocationMatch = Boolean(props.isLocationMatch);

    const handleClick = () => {
        if (isDisabled) {
            return;
        }

        setStores((prevStores) => ({
            ...prevStores,
            [props.storeName]: {
                ...prevStores[props.storeName],
                selected: !prevStores[props.storeName].selected,
            },
        }));
    };

    return (
        <div className={props.wrapperClassName || 'justify-content-center pb-2 align-self-center'}>
            <div
                className={`storeSelectorButton${isSelected ? ' selected' : ''}${isLocationMatch ? ' is-location-match' : ''}${isDisabled ? ' is-disabled' : ''}`}
                data-store={normalizedStoreKey}
                onClick={handleClick}
                role="button"
                tabIndex={isDisabled ? -1 : 0}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleClick();
                    }
                }}
                aria-label={isLocationMatch
                    ? `${displayName} er fundet i radius og ${isSelected ? 'valgt' : 'ikke valgt'}`
                    : isDisabled
                        ? `${displayName} er ikke fundet i radius`
                        : `${isSelected ? 'Fravælg' : 'Vælg'} ${displayName}`}
                aria-disabled={isDisabled}
                aria-pressed={isSelected}
            >
                {isLocationMatch && isSelected && (
                    <span className="store-location-match-badge" aria-hidden="true">Fundet</span>
                )}
                <div className="text-center storeLogoFrame">
                    <img alt={displayName} src={props.logo} className="storeLogo" data-store={normalizedStoreKey} />
                </div>
                <div className="text-center storeSelectorName">{displayName}</div>
            </div>
        </div>
    );
};

export default StoreSelector;
